/* Recently viewed (sections/recently-viewed.liquid).

   The list lives in this browser and nowhere else: a product id is written on every product page
   and read back wherever the section sits. Nothing is sent anywhere, and nothing is stored about
   who the shopper is.

   The cards themselves still come from the server — the ids become a /search query with
   section_id, so Liquid renders the price and the badges, the same rule the cart and the
   recommendations follow. */

const KEY = 'mw:recently-viewed';
const MAX = 12;
const SHELL = '[data-recently-viewed]';

function read() {
  try {
    const raw = window.localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((id) => Number.isFinite(id)) : [];
  } catch {
    /* Private window, cleared storage, storage disabled: there is simply no history. */
    return [];
  }
}

function remember(id) {
  if (!Number.isFinite(id)) return;
  try {
    const list = [id, ...read().filter((other) => other !== id)].slice(0, MAX);
    window.localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* Nothing to do: the page works without a history. */
  }
}

async function fill(shell) {
  if (shell.dataset.done) return;
  shell.dataset.done = '1';

  const current = Number(shell.dataset.current);
  const limit = Number(shell.dataset.limit) || 4;
  const ids = read()
    .filter((id) => id !== current)
    .slice(0, limit);
  if (!ids.length) {
    shell.remove();
    return;
  }

  const query = ids.map((id) => `id:${id}`).join(' OR ');
  try {
    const response = await fetch(`${shell.dataset.searchUrl}${encodeURIComponent(query)}`, {
      headers: { Accept: 'text/html' },
    });
    if (!response.ok) throw new Error(response.statusText);
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fresh = parsed.querySelector('.prec__inner');
    if (!fresh) {
      shell.remove();
      return;
    }
    shell.replaceChildren(fresh);
    shell.classList.add('is-filled');
    window.Munkwell?.motion?.scan?.(shell);
  } catch {
    shell.remove();
  }
}

/* Remember this page before anything else: a shopper who leaves straight away should still have
   been here. */
const current = Number(document.querySelector(SHELL)?.dataset.current);
if (Number.isFinite(current)) remember(current);

const observer =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries, self) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            self.unobserve(entry.target);
            fill(entry.target);
          });
        },
        { rootMargin: '600px 0px' }
      )
    : null;

function scan(scope = document) {
  scope.querySelectorAll(SHELL).forEach((shell) => {
    if (observer) observer.observe(shell);
    else fill(shell);
  });
}

scan();
document.addEventListener('shopify:section:load', (event) => scan(event.target));
